import { memo, useCallback, useContext } from 'react'
import { Flyout, SlideUp } from 'common-components'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useEventListener } from 'hooks'
import { ScrollableElementContext } from 'containers/SubSidebar/AiImageContent/contextApi'
import ImageStylesContent from '../Content'
import { IAiImageStylesState } from 'store/types/aiImage'

interface IProps {
  isOpen: boolean
  onClose: () => void
  anchorRef: React.RefObject<HTMLDivElement | null>
  selectedStyleId: string | number
  styles: IAiImageStylesState
  onStyleClick: (id: string | number) => void
}

const AiImageStylesFlyout: React.FC<IProps> = ({
  isOpen,
  onClose,
  anchorRef,
  selectedStyleId,
  onStyleClick,
  styles
}) => {
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const { scrollableElementRef } = useContext(ScrollableElementContext)

  const handleStyleClick = useCallback(
    (id: string | number) => {
      onStyleClick(id)
      onClose()
    },
    [onClose, onStyleClick]
  )

  useEventListener('scroll', onClose, scrollableElementRef?.current)

  if (!anchorRef?.current) return null

  if (isTablet) {
    return (
      <SlideUp isOpen={isOpen} onClose={onClose}>
        <ImageStylesContent
          styles={styles}
          handleStyleClick={handleStyleClick}
          currentStyleId={selectedStyleId}
        />
      </SlideUp>
    )
  }

  return (
    <Flyout
      isOpen={isOpen}
      anchorEl={anchorRef.current}
      onClose={onClose}
      options={{
        position: 'right',
        alignmentY: 'bottom',
        extraOffset: 10
      }}
      style={{ y: 20 }}
    >
      <ImageStylesContent
        styles={styles}
        handleStyleClick={handleStyleClick}
        currentStyleId={selectedStyleId}
      />
    </Flyout>
  )
}

export default memo(AiImageStylesFlyout)
